import { h } from 'preact'
import { i18n } from 'i18n/i18n'
import { useRegistryUrl } from 'hooks/useRegistryUrl'
import { CalculatorCtaButton } from 'common-modules/calculator-cta-button'

interface ExchangeButtonsProps {
  showAlert: boolean
}

const ExchangeButtons = ({ showAlert }: ExchangeButtonsProps) => {
  const registryUrl = useRegistryUrl()

  const handleClickOnAlertButton = () => {
    const $alertElement = document.querySelector<HTMLElement>('#currency-rate-notification')
    if ($alertElement) {
      $alertElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  }

  return (
    <div className="double-input-calculator__buttons">
      <CalculatorCtaButton href={registryUrl} />

      {showAlert && (
        <button
          className="double-input-calculator__button button button--secondary button--fw-600"
          type="button"
          data-alert-button
          onClick={handleClickOnAlertButton}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="currentColor"
            viewBox="0 0 24 24"
            className="alert-bell-svg"
            aria-hidden="true"
          >
            <path d="M10 21a2 2 0 1 0 4 0h-4zm8.9-4.2V11c0-3.3-2.3-6-5.3-6.7v-.7a1.6 1.6 0 1 0-3.2 0v.7C7.4 5 5.1 7.8 5.1 11v5.8L3 19v1h18v-1l-2.1-2.2zM16 13h-3v3h-2v-3H8v-2h3V8h2v3h3v2z" />
          </svg>
          {i18n('rateCalculator.ctaAlert')}
        </button>
      )}
    </div>
  )
}

export default ExchangeButtons
